import { AxiosRequestConfig, AxiosResponse } from "axios";
import { useState, useEffect } from "react";
import assetClient from "src/services/assetClient";

export const useAzureFileDownload = (
	uploadType: string,
	uuid?: string | null,
	imageProfile?: ImageProfile
) => {
	const [data, setData] = useState();
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState();

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const onDownloadSuccess = (response: AxiosResponse<any>) => {
		setData(response.data);
		setIsLoading(false);
	};

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const onDownloadFailed = (reason: any) => {
		setError(reason);
		setIsLoading(false);
	};

	const download = () => {
		setIsLoading(true);

		const axiosConfig = {
			headers: {
				"Content-Type": "multipart/form-data",
				Accept: "application/json"
			},
			params: {
				profileName: imageProfile
			}
		} as AxiosRequestConfig;

		assetClient
			.get(
				`/api/v1.0/asset/${uploadType}/${uuid}${
					uploadType === "image" ? "/all" : ""
				}`,
				axiosConfig
			)
			.then(onDownloadSuccess, onDownloadFailed);
	};

	useEffect(() => {
		setData(undefined);
		setError(undefined);

		if (!uuid) return;

		download();
	}, [uuid]);

	return {
		data,
		error,
		isLoading,
		download
	};
};
